module.exports = __webpack_public_path__ + "img/2.bd29b64a.png";